import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import { FC, useMemo, useRef } from 'react';

import DialogFlowContainer from './DialogFlowContainer';

interface Props {
  clientSecret: string;
}

export const DialogFlowWithStripe: FC<Props> = ({ clientSecret }) => {
  const stripePromise = useRef(loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY!));

  const options: StripeElementsOptions = useMemo(
    () => ({
      clientSecret,
      appearance: {
        theme: 'stripe',
        variables: {
          colorText: 'rgb(29, 22, 17)',
          colorDanger: 'rgb(255, 82, 7)',
          colorDangerText: 'rgb(255, 82, 7)',
          colorSuccess: 'rgb(5, 123, 79)',
          colorSuccessText: 'rgb(5, 123, 79)',
          colorPrimaryText: 'rgb(43, 32, 17)',
          colorTextPlaceholder: 'rgba(255, 255, 255, 0.7)',
          fontSizeSm: '1rem',
          fontFamily: '"Rima Avant Arte", "Arial", "sans-serif"',
        },
      },
      fonts: [
        {
          family: 'Rima Avant Arte',
          src: 'url(https://avantarte.com/fonts/RimaAvant-Arte-Regular.woff2)',
          weight: 'normal',
          style: 'normal',
          display: 'swap',
        },
      ],
    }),
    [clientSecret],
  );

  return (
    <Elements options={options} stripe={stripePromise.current}>
      <DialogFlowContainer containerId="stripe" />
    </Elements>
  );
};
